/* global window */
/* global document */
import React, {Fragment} from 'react'
import NProgress from 'nprogress'
import {connect} from 'dva'
import {withRouter} from 'dva/router'
import '../themes/index.less'
import './app.less'
import Header from "./Header"
import Footer from "./Footer"

let lastHref

const App = ({
               children, dispatch, app, loading, location
             }) => {
  const {} = app
  let {pathname} = location
  pathname = pathname.startsWith('/') ? pathname : `/${pathname}`
  const {href} = window.location

  if (lastHref !== href) {
    NProgress.start()
    if (!loading.global) {
      NProgress.done()
      lastHref = href
    }
  }

  if (pathname === '/') {
    return children
  }

  return (
    <Fragment>
      <Header pathname={pathname}/>
      {children}
      <Footer/>
    </Fragment>
  )
}

export default withRouter(connect(({
                                     app, loading, modifyPassword,
                                   }) => ({
  app, loading, modifyPassword,
}))(App))
